import { Project } from 'api/models';
import * as yup from 'yup';

export const getProjectValidationSchema = (t: (key: string) => string) => {
  return yup.object({
    name: yup.string().required(t('general.errors.mandatoryField') ?? ''),
    shortName: yup
      .string()
      .min(3, t('projectCreation.errors.shortNameTooShort') ?? '')
      .required(t('general.errors.mandatoryField') ?? ''),
    description: yup.string(),
    requiredPatientFields: yup.array().of(yup.string()),
  });
};

export const initialProjectValues = {
  name: '',
  shortName: '',
  description: '',
  automaticProjectId: false,
  editableProjectId: false,
  samplesEnabled: false,
  queryModuleEnabled: false,
  repeatingFieldsEnabled: false,
  requiredPatientFields: [],
  longDescription: '',
};

export const getProjectInitialValues = (
  project: Project | undefined | null,
) => {
  return project
    ? {
        name: project.name,
        shortName: project.shortName,
        description: project.description,
        automaticProjectId: project.configuration?.automaticProjectId ?? false,
        editableProjectId: project.configuration?.editableProjectId ?? false,
        samplesEnabled: project.configuration?.samplesEnabled ?? false,
        queryModuleEnabled: project.configuration?.queryModuleEnabled ?? false,
        repeatingFieldsEnabled:
          project.configuration?.repeatingFieldsEnabled ?? false,
        requiredPatientFields: project.requiredPatientFields ?? [],
        longDescription: project.longDescription ?? '',
      }
    : initialProjectValues;
};
